
import Vue from 'vue'
import Vuex from 'vuex'
import createMutationsSharer from 'vuex-shared-mutations'

import User from './modules/user/index.js'
import Regions from './modules/regions'
import Helpers from './modules/helpers'
import Clinics from './modules/clinicStore/store'
import ClinicTypes from './modules/clinicStore/types'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        User,
        Clinics,
        Regions,
        ClinicTypes,
        Helpers
    },
    plugins: [createMutationsSharer({ predicate: ['LOAD_ALL_CLINICS'] })],

    strict: process.env.NODE_ENV !== 'production'
})